const storage = localStorage;

const keys = {
    announcement: 'Announcement',
};

const get = <T = unknown>(key: string) => (storage.getItem(key) ? (JSON.parse(storage.getItem(key)!) as T) : null);
const set = <T = unknown>(key: string, value: T) => storage.setItem(key, JSON.stringify(value));

export const localStore = { get, set, keys };
